var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("b-table", {
    attrs: {
      fields: _vm.fields,
      items: _vm.items,
      "table-class": "text-nowrap",
      responsive: "",
      hover: "",
    },
    on: { "row-clicked": _vm.onClickRow },
    scopedSlots: _vm._u([
      {
        key: "cell(company_name)",
        fn: function (data) {
          return [
            _c("h4", { staticClass: "mb-0" }, [
              _vm._v(_vm._s(data.item.company_name)),
            ]),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }